import { Link } from 'react-router-dom'

import { brandifyNode } from '@/components/brand/kindlumen'
import { SeoHead } from '@/components/seo/seo-head'
import { Button } from '@/components/ui/button'
import { createMetadata } from '@/lib/seo'

const metadata = createMetadata({
  path: '/404',
  title: 'Page not found | KindLumen',
  description: 'The page you requested does not exist.',
  keywords: [],
  noIndex: true,
})

export default function NotFoundPage() {
  return (
    <>
      <SeoHead metadata={metadata} />
      <div className="section-shell flex min-h-screen items-center justify-center py-12">
        <div className="panel max-w-2xl text-center p-10">
          <div className="eyebrow mx-auto">404</div>
          <h1 className="mt-6 text-4xl font-semibold leading-[1.16] sm:text-5xl sm:leading-[1.12]">
            We couldn’t find that page.
          </h1>
          <p className="mt-4 text-lg leading-8 text-ink-soft">
            {brandifyNode(
              'The page you’re looking for may have moved or no longer exists. Use the buttons below to get back on track.',
            )}
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button asChild>
              <Link to="/">Go to homepage</Link>
            </Button>
            <Button asChild variant="secondary">
              <Link to="/dashboard">Open dashboard</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
